import { Reveal } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

const PETER_IMG = "/founders/peter-dive.jpg";
const LILIAN_IMG = "/founders/lilian-main.jpg";

export default function Founders() {
  const { t } = useLanguage();

  return (
    <section id="founders" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-40" data-testid="founders-section">
      <Reveal>
        <p className="font-jetbrains text-xs uppercase tracking-[0.35em] text-volt mb-6">{t("founders.chapter")}</p>
      </Reveal>

      <div className="grid md:grid-cols-8 gap-6">
        <Reveal className="md:col-span-5 bg-surface border border-white/10 p-8 md:p-14 flex flex-col justify-between min-h-[320px]">
          <h2 className="font-cabinet font-black uppercase text-3xl md:text-5xl leading-[1.02] tracking-tight">
            {t("founders.h2a")}<span className="text-volt">{t("founders.h2b")}</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg leading-relaxed mt-8 max-w-xl">
            {t("founders.intro")}
          </p>
        </Reveal>

        <Reveal delay={0.1} className="md:col-span-3 md:row-span-2 relative overflow-hidden border border-white/10 min-h-[420px]">
          <img src={PETER_IMG} alt="Peter Rogenthien, goalkeeper" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-[filter] duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
          <div className="absolute bottom-0 p-6">
            <p className="font-jetbrains text-[10px] uppercase tracking-[0.3em] text-volt">{t("founders.peterCap")}</p>
            <p className="font-cabinet font-black uppercase text-2xl mt-1">Peter Rogenthien</p>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-5 bg-surface border border-white/10 p-8 md:p-12">
          <p className="font-jetbrains text-xs uppercase tracking-[0.3em] text-white/40 mb-4">{t("founders.peterLabel")}</p>
          <p className="text-white/70 leading-relaxed text-base md:text-lg">
            {t("founders.peterBio")}
          </p>
          <p className="font-jetbrains text-xs uppercase tracking-[0.2em] text-volt/80 mt-6">
            {t("founders.peterAcademies")}
          </p>
        </Reveal>

        <Reveal delay={0.1} className="md:col-span-3 md:row-span-2 relative overflow-hidden border border-white/10 min-h-[420px]">
          <img src={LILIAN_IMG} alt="Lilian Benjamin in action" className="absolute inset-0 w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-[filter] duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
          <div className="absolute bottom-0 p-6">
            <p className="font-jetbrains text-[10px] uppercase tracking-[0.3em] text-volt">Paris → Cardiff → Cape Breton → Algoma</p>
            <p className="font-cabinet font-black uppercase text-2xl mt-1">Lilian Benjamin</p>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-5 bg-surface border border-white/10 p-8 md:p-12">
          <p className="font-jetbrains text-xs uppercase tracking-[0.3em] text-white/40 mb-4">{t("founders.lilianLabel")}</p>
          <p className="text-white/70 leading-relaxed text-base md:text-lg">
            {t("founders.lilianBio")}
          </p>
        </Reveal>

        <Reveal delay={0.2} className="md:col-span-5 bg-volt text-obsidian p-8 md:p-12" data-testid="honesty-card">
          <p className="font-playfair italic text-2xl md:text-4xl leading-snug">
            {t("founders.quote")}
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="mt-6 grid md:grid-cols-2 gap-6" data-testid="founders-matchday-strip">
        <div className="relative overflow-hidden border border-white/10 h-72 md:h-96">
          <img src="/founders/peter-main.jpg" alt="Peter Rogenthien commanding his box" className="absolute inset-0 w-full h-full object-cover object-[50%_55%] grayscale hover:grayscale-0 transition-[filter] duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <p className="absolute bottom-4 left-5 font-jetbrains text-[10px] uppercase tracking-[0.3em] text-white/70">{t("founders.stripPeter")}</p>
        </div>
        <div className="relative overflow-hidden border border-white/10 h-72 md:h-96">
          <img src="/founders/lilian-capers.jpg" alt="Lilian Benjamin driving at the defence" className="absolute inset-0 w-full h-full object-cover object-[50%_10%] grayscale hover:grayscale-0 transition-[filter] duration-700" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <p className="absolute bottom-4 left-5 font-jetbrains text-[10px] uppercase tracking-[0.3em] text-white/70">{t("founders.stripLilian")}</p>
        </div>
      </Reveal>
    </section>
  );
}
